import {CurrentStateValidator} from '@colonist/game-mechanic-validators'
import {useGameStore} from '../GameStoreContext'
import {useMemo} from 'react'

export const useCurrentStateValidator = () => {
    const currentState = useGameStore((state) => state.gameState.currentState)
    const experimentalMechanicState = useGameStore((state) => state.gameState.experimentalMechanicState)
    const playerColors = useGameStore((state) => state.gameDetails.playOrder)

    const experimentalCurrentState = experimentalMechanicState?.currentState
    const mechanicTurnColonistRushState = experimentalMechanicState?.mechanicTurnColonistRushState
    const playerStates = experimentalMechanicState?.playerStates
    const mechanicRobberColonistRushState = experimentalMechanicState?.mechanicRobberColonistRushState
    return useMemo(() => new CurrentStateValidator(currentState, experimentalCurrentState, mechanicTurnColonistRushState, playerStates, playerColors, mechanicRobberColonistRushState)
        , [currentState, experimentalMechanicState, playerStates, playerColors])
}
